import { useRef, type FC } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { TriangleAlertIcon } from 'lucide-react';
import useDomain from '@/hooks/useDomain';
import { useGetMcpAutoBudgetQuery } from '../api/mcpApi';

const AI_SETTINGS_PATH = '/settings/ai';
const LABEL = 'بودجه دو برابری';

/**
 * Shown while the domain owner has no verified API key. Explains how the
 * daily Auto budget gets doubled: by the viewer when they own the domain,
 * otherwise by the domain owner.
 */
export const McpAutoBudgetDoubleHint: FC = () => {
  const { domain_slug: domainSlug } = useDomain();
  const { data } = useGetMcpAutoBudgetQuery(domainSlug ?? '', {
    skip: !domainSlug
  });
  // Popovers must render inside the chat page, or fullscreen hides them.
  const containerRef = useRef<HTMLSpanElement>(null);

  if (!domainSlug || !data || data.budgetDoubled !== false) return null;

  const isOwner = data.isDomainOwner !== false;

  return (
    <span ref={containerRef} className="d-inline-flex">
      <OverlayTrigger
        trigger="click"
        rootClose
        placement="bottom"
        container={containerRef}
        overlay={
          <Popover id="mcp-auto-budget-double-hint" dir="rtl">
            <Popover.Header as="h6" className="fs--1">
              دو برابر کردن بودجهٔ روزانهٔ Auto
            </Popover.Header>
            <Popover.Body className="fs--1">
              {isOwner ? (
                <>
                  اگر یک API key فعال وارد کنید و تأیید شود، بودجهٔ روزانهٔ
                  رایگان Auto برای دامنه‌های شما دو برابر می‌شود.
                  <div className="mt-2">
                    <Link to={AI_SETTINGS_PATH}>رفتن به تنظیمات AI</Link>
                  </div>
                </>
              ) : (
                <>
                  اگر صاحب این دامنه یک API key فعال وارد کند و تأیید شود،
                  بودجهٔ روزانهٔ رایگان Auto این دامنه دو برابر می‌شود.
                </>
              )}
            </Popover.Body>
          </Popover>
        }
      >
        <button
          type="button"
          className="mcp-chat-pill-btn mcp-chat-pill-btn--ghost mcp-chat-pill-btn--sm"
          aria-label={LABEL}
        >
          <TriangleAlertIcon
            className="text-warning"
            size={13}
            strokeWidth={2.25}
            aria-hidden
          />
          <span>{LABEL}</span>
        </button>
      </OverlayTrigger>
    </span>
  );
};
